import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { useAlert } from 'hooks';
import { useTrackStepDocumentDownloadMutation } from 'store/api/course-submissions';

import { Icon } from '../icons';
import { Button } from '../button';

import { DownloadPdfButtonProps } from './types';

export const DownloadPdfButton = ({
  title,
  fileName,
  submissionId,
}: DownloadPdfButtonProps) => {
  const [isDownloading, setDownloading] = useState(false);
  const { handleError } = useAlert();
  const { t } = useTranslation(['common']);
  const [trackStepDocumentDownload] = useTrackStepDocumentDownloadMutation();

  const onDownload = async () => {
    try {
      setDownloading(true);

      const response = await api.pdf.downloadPdf();
      const url = window.URL.createObjectURL(new Blob([response.data]));

      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName || 'Certificate'}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);

      if (submissionId) {
        await trackStepDocumentDownload(submissionId).unwrap();
      }
    } catch (error) {
      handleError(error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Button
      className="px-4"
      onClick={onDownload}
      disabled={isDownloading}
      startIcon={<Icon.Resource className="[&>path]:fill-current" />}
    >
      {title ?? t('downloadPDF')}
    </Button>
  );
};
